/**
 * Casulo B2B - Cart Validation Utility
 * Previne a mistura de produtos 'Loja' (Pronta-entrega) com 'Orçamento'.
 */
window.CasuloCart = window.CasuloCart || {};

window.CasuloCart.Validation = {
  /**
   * Obtém o ID do cliente Shopify logado
   */
  getCustomerId() {
    return window.__casulo_customer_id || 
           (window.Shopify && window.Shopify.customer ? window.Shopify.customer.id : null) || 
           (window.__st && window.__st.cid ? window.__st.cid : null);
  },

  /**
   * Obtém ou gera um ID único para o navegador (Guest)
   */
  getBrowserId() {
    let bid = localStorage.getItem('__casulo_browser_id');
    if (!bid) {
      bid = 'bid_' + Math.random().toString(36).substring(2, 11) + Date.now();
      localStorage.setItem('__casulo_browser_id', bid);
    }
    return bid;
  },

  /**
   * Valida se um produto pode ser adicionado ao carrinho atual via API.
   * @param {string} collectionsStr - Handles de coleções do novo produto.
   * @returns {Promise<{valid: boolean, message: string, newType: string}>}
   */
  async validateAddition(collectionsStr) {
    // 0. Verificar se o carrinho do Shopify está vazio. Se sim, limpamos o virtual antes.
    try {
      const cartRes = await fetch(`${window.routes?.cart_url || '/cart'}.js?t=${Date.now()}`, {
        cache: 'no-store',
        headers: { 'Cache-Control': 'no-cache' }
      });
      const cart = await cartRes.json();
      if (!cart.items || cart.items.length === 0) {
        console.log('[CasuloCart] Carrinho Shopify vazio comprovado. Limpando carrinho virtual...');
        // Chamada não-autobloqueante para não atrasar a validação principal
        fetch('/apps/orcamento/orcamento/clear-cart', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            customer_id: this.getCustomerId(),
            browser_id: this.getBrowserId()
          })
        }).catch(() => {});
      }
    } catch (e) {
      console.warn('[CasuloCart] Erro ao pré-validar carrinho Shopify (continuando...):', e);
    }

    // 1. Identificar o tipo do novo produto localmente primeiro
    const collections = (collectionsStr || '').split(',').map(c => c.trim().toLowerCase());
    const isNewLoja = collections.some(c => ['loja', 'pronta-entrega'].includes(c));
    const newType = isNewLoja ? 'loja' : 'orcamento';

    console.log('[CasuloCart] Validando adição tipo:', newType);

    try {
      // 2. Chamar API de Validação
      const response = await fetch('/apps/orcamento/orcamento/validate-addition', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          customer_id: this.getCustomerId(),
          browser_id: this.getBrowserId(),
          product_type: newType
        })
      });

      const result = await response.json();
      
      if (result.valid) {
        return { valid: true, newType };
      } else {
        return {
          valid: false,
          message: result.message || 'Mistura de produtos não permitida.',
          newType
        };
      }
    } catch (e) {
      console.error('[CasuloCart] Erro na validação via API:', e);
      // Fallback em caso de erro na API: permitir para não quebrar a loja, 
      // mas logar o erro.
      return { valid: true, newType };
    }
  },

  /**
   * Remove itens do carrinho que não correspondem ao tipo que o usuário deseja manter.
   * @param {'loja' | 'orcamento'} keepType - O tipo de produto que deve permanecer.
   */
  async resolveConflict(keepType) {
    console.log('[CasuloCart] Resolvendo conflito... Mantendo:', keepType);
    try {
      // 1. Buscar carrinho atual
      const cartRes = await fetch(`${window.routes?.cart_url || '/cart'}.js?t=${Date.now()}`);
      const cart = await cartRes.json();
      const updates = {};
      let hasRemovals = false;

      // 2. Identificar itens a remover
      cart.items.forEach(item => {
        // Busca a propriedade. Se não existir, tenta inferir das tags/coleções via DOM (se disponível) ou usa fallback.
        let itemType = item.properties && item.properties._product_type ? item.properties._product_type : null;
        
        if (!itemType) {
          // Se não tem propriedade, buscamos no DOM por coleções (caso o usuário esteja no carrinho/drawer)
          const row = document.querySelector(`[data-variant-id="${item.variant_id}"], [data-id="${item.key}"]`);
          const collectionsStr = row ? (row.dataset.productCollections || '') : '';
          const collections = collectionsStr.split(',').map(c => c.trim().toLowerCase());
          const isLoja = collections.some(c => ['loja', 'pronta-entrega'].includes(c));
          itemType = isLoja ? 'loja' : 'orcamento';
        }

        if (itemType !== keepType) {
          updates[item.key] = 0;
          hasRemovals = true;
        }
      });

      if (hasRemovals) {
        // 3. Atualizar carrinho (remover itens)
        await fetch(`${window.routes?.cart_update_url || '/cart/update'}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        });

        // 4. Limpar estado virtual no backend (opcional mas recomendado)
        // Se mantivermos apenas 'loja', limpamos o virtual. Se for 'orcamento', o backend já sabe o estado.
        if (keepType === 'loja') {
          await fetch('/apps/orcamento/orcamento/clear-cart', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              customer_id: this.getCustomerId(),
              browser_id: this.getBrowserId()
            })
          }).catch(() => {});
        }
      }

      // 5. Recarregar a página para atualizar o estado visual
      window.location.reload();
    } catch (e) {
      console.error('[CasuloCart] Erro ao resolver conflito:', e);
      alert('Erro ao processar sua solicitação. Por favor, tente remover os itens manualmente.');
    }
  }
};

/**
 * Casulo B2B - Auth Choice Modal Global Logic
 */
window.CasuloAuthState = window.CasuloAuthState || {
  targetFormId: null,
  targetFlow: 'checkout' // 'checkout' or 'orcamento'
};

window.openCasuloAuthModal = function(formId, flowType = 'checkout') {
  window.CasuloAuthState.targetFormId = formId;
  window.CasuloAuthState.targetFlow = flowType;
  console.log('[CasuloAuth] Abrindo modal para fluxo:', flowType);
  const modal = document.getElementById('casulo-auth-choice-modal');
  if (modal) {
    modal.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  } else {
    console.error('[CasuloAuth] Modal não encontrado no DOM.');
  }
};

window.closeCasuloAuthModal = function() {
  const modal = document.getElementById('casulo-auth-choice-modal');
  if (modal) {
    modal.style.display = 'none';
    document.body.style.overflow = '';
  }
};

window.handleCasuloAuthChoice = function(choice) {
  const loginUrl = '/customer_authentication/login';

  if (choice === 'cadastro') {
    const flow = window.CasuloAuthState.targetFlow;
    if (flow === 'orcamento') {
      console.log('[CasuloAuth] Redirecionando para lead modal (orcamento)...');
      if (window.openLeadModal) {
        window.openLeadModal();
      } else if (window.CasuloCart?.Lead?.open) {
        window.CasuloCart.Lead.open();
      } else {
        console.warn('[CasuloAuth] Função openLeadModal não encontrada.');
        alert('Carregando sistema de orçamentos...');
      }
    } else {
      console.log('[CasuloAuth] Seguindo para login unificado (cadastro e login usam o mesmo fluxo sem senha)...');
      window.location.href = loginUrl;
    }
  } else if (choice === 'login') {
    window.location.href = loginUrl;
  }
  window.closeCasuloAuthModal();
};
